var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferredLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17152",
    "data-name": "Group 17152",
    transform: "translate(-378 -279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(378 279)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16442",
    "data-name": "Group 16442",
    transform: "translate(382 280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "japan",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8257",
    "data-name": "Path 8257",
    d: "M168.488,90a3.173,3.173,0,1,0,3.173,3.173A3.176,3.176,0,0,0,168.488,90Zm0,4.759a1.586,1.586,0,1,1,1.586-1.586A1.588,1.588,0,0,1,168.488,94.759Z",
    transform: "translate(-162.134 -86.827)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8258",
    "data-name": "Path 8258",
    d: "M240.844,165a.529.529,0,1,0,.529.529A.529.529,0,0,0,240.844,165Z",
    transform: "translate(-234.49 -159.184)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8259",
    "data-name": "Path 8259",
    d: "M81.418,0a6.352,6.352,0,0,0-6.345,6.345C74.831,8.736,79.6,15.732,81,17.454l.419.546.419-.546C83.256,15.7,88,8.727,87.763,6.345A6.352,6.352,0,0,0,81.418,0Zm0,10.575a4.23,4.23,0,1,1,4.23-4.23A4.235,4.235,0,0,1,81.418,10.575Z",
    transform: "translate(-75.064)",
    fill: "#3f2566"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferredLocation);
export default __webpack_public_path__ + "static/media/preferred_location.af1b9f8ce1a78eee3bb117b7ab351002.svg";
export { ForwardRef as ReactComponent };